<div class="bz-trace-node-list">
  <h5 class="bz-trace-node-list__title bz-space--stack-xl">{{'TRACE_CONFIGURATION.TITLE' | translate}}</h5>
  <bz-loading class="bz-trace-node-list__loading" [showLoading]="showLoading" [message]="loadingMessage">
  </bz-loading>
  <bzg-button-secondary class="bmc-expiration-session__icon-exit" icon="edit" [bzgMenuTrigger]="optionsMenu"
  [bzgMenuYPosition]="'below'" [bzgMenuXPosition]="'before'" [filled]="false">{{'TRACE_CONFIGURATION.EDIT_TRACES' | translate}}</bzg-button-secondary>
  <div class="bz-trace-node-list-nodes" *ngIf="!showLoading">
    <biz-trace-node [nodes]="nodes" [showMenuOption]="showMenuOption" [nameParent]="" (emitNodes)="getNodes($event)" ></biz-trace-node>
  </div>
  <bzg-menu #optionsMenu>
    <bzg-menu-item (click)="onToggleSelectAll('Off')">
      <bzg-icon class="bz-trace-node-list-menu-icon bz-space--inline-s" [nameIcon]="'icon-minus'">
      </bzg-icon>
      <span>{{ 'TRACE_CONFIGURATION.NONE' | translate }}</span>
    </bzg-menu-item>
    <bzg-menu-item (click)="onToggleSelectAll('Info')">
      <bzg-icon class="bz-trace-node-list-menu-icon bz-space--inline-s" color="info" [nameIcon]="'icon-info-strong'">
      </bzg-icon>
      <span>{{ 'TRACE_CONFIGURATION.INFO' | translate }}</span>
    </bzg-menu-item>
    <bzg-menu-item (click)="onToggleSelectAll('Warning')">
      <bzg-icon class="bz-trace-node-list-menu-icon bz-space--inline-s" color="warning" [nameIcon]="'icon-warning'">
      </bzg-icon>
      <span>{{ 'TRACE_CONFIGURATION.WARNING' | translate }}</span>
    </bzg-menu-item>
    <bzg-menu-item (click)="onToggleSelectAll('Error')">
      <bzg-icon class="bz-trace-node-list-menu-icon bz-space--inline-s" color="error" [nameIcon]="'icon-error'">
      </bzg-icon>
      <span>{{ 'TRACE_CONFIGURATION.ERROR' | translate }}</span>
    </bzg-menu-item>
  </bzg-menu>
</div>
